import { FC, RefObject } from 'react';

import { Loader } from '@mopla/ui';

import { RouteMapDiv, RouteMapLoaderContainer, RouteMapRoot } from './styled';

interface IRouteMapViewProps {
	mapRef: RefObject<HTMLDivElement>;
	isMapLoading: boolean;
}

export const RouteMapView: FC<IRouteMapViewProps> = ({
	mapRef,
	isMapLoading,
}) => {
	return (
		<RouteMapRoot>
			{isMapLoading && (
				<RouteMapLoaderContainer>
					<Loader delay={100} />
				</RouteMapLoaderContainer>
			)}
			<RouteMapDiv ref={mapRef} />
		</RouteMapRoot>
	);
};
